import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

export enum HeroLayout {
  HideImage = 'hideImage',
  ImageRight = 'imageRight',
  ImageLeft = 'imageLeft',
  ImageTop = 'imageTop',
}

const HeroCtaTextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('ctaText'),
  role: z.literal(FieldRole.CtaText),
});

const HeroCtaUrlFieldSchema = UrlFieldSchema.extend({
  name: z.literal('ctaUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

const HeroHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const HeroImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('image'),
  role: z.literal(FieldRole.Image),
});

const HeroBackgroundImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('bgImage'),
  role: z.literal(FieldRole.Image),
});

const HeroPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const HeroSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

const HeroFieldSchema = z.discriminatedUnion('name', [
  HeroCtaTextFieldSchema,
  HeroCtaUrlFieldSchema,
  HeroHeaderFieldSchema,
  HeroImageFieldSchema,
  HeroBackgroundImageFieldSchema,
  HeroPreheaderFieldSchema,
  HeroSubheaderFieldSchema,
]);

const HeroFieldGroupSchema = FieldGroupSchema.extend({ fields: z.array(HeroFieldSchema) });

const HeroLayoutSchema = z.nativeEnum(HeroLayout);

export const HeroBlockOptionsSchema = z.object({
  layout: HeroLayoutSchema.optional(),
  preheaderEnabled: z.boolean().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
      backgroundPosition: z.string().optional(),
      backgroundImage: z.string().optional(),
    })
    .optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

export type HeroBlockOptions = z.infer<typeof HeroBlockOptionsSchema>;

export const HeroBlockConfigSchema = z.object({
  options: HeroBlockOptionsSchema,
  type: z.literal(BlockType.Hero),
  fieldGroups: z.tuple([HeroFieldGroupSchema]).rest(HeroFieldGroupSchema),
  version: z.literal(1),
});
